// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__LXvUJ","loader":"MediumLoader_loader__Qq-by","spinner-c7wet2":"MediumLoader_spinner-c7wet2__xVj7v"};